import { useEffect } from "react";

import { absoluteUrl, seoFor } from "@/config/seo";

const setTag = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.rel ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

// Met à jour <title>, description, Open Graph et canonical pour la page publique courante
export const Seo = ({ path }) => {
  useEffect(() => {
    const { title, description, image } = seoFor(path);
    const url = absoluteUrl(path);
    document.title = title;
    setTag('meta[name="description"]', { name: "description", content: description });
    setTag('meta[property="og:title"]', { property: "og:title", content: title });
    setTag('meta[property="og:description"]', { property: "og:description", content: description });
    setTag('meta[property="og:image"]', { property: "og:image", content: image });
    setTag('meta[property="og:url"]', { property: "og:url", content: url });
    setTag('meta[property="og:type"]', { property: "og:type", content: "website" });
    setTag('link[rel="canonical"]', { rel: "canonical", href: url });
  }, [path]);
  return null;
};
